import { render, staticRenderFns } from "./form-complete.vue?vue&type=template&id=2edcb8a2"
import script from "./form-complete.vue?vue&type=script&lang=js"
export * from "./form-complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports